import { useEffect, useFeatureIsOn } from '@frontend/react';
import { PageContainer, Text, YStack } from '@frontend/web-react';
import { LetterRecommendationsContainer, TrendingTasksContainer } from '@frontend/web/components';
import { DirectoryCard } from '@frontend/web/components/DomainSpecific/DirectoryCard';
import { useFooterVisibility, useListExamplesQuery, useListLetterRecommendationsQuery } from '@frontend/web/hooks';
import { createFileRoute } from '@tanstack/react-router';

const Discover = () => {
  const { enabled: isDiscoverTabEnabled } = useFeatureIsOn('is_discover_tab_enabled');
  const {
    data: letterRecommendations,
    isLoading: isLetterRecommendationLoading,
    isSuccess: isLetterRecommendationSuccess,
  } = useListLetterRecommendationsQuery();

  const { data: examples, isLoading: isExamplesLoading, isSuccess: isListExamplesSuccess } = useListExamplesQuery();
  const navigate = Route.useNavigate();

  const isAnyLoading = isLetterRecommendationLoading || isExamplesLoading;

  const completedInitialFetch = isLetterRecommendationSuccess && isListExamplesSuccess;

  const { handleScroll, isFooterVisible } = useFooterVisibility();

  useEffect(() => {
    if (!isDiscoverTabEnabled) {
      navigate({ to: '/app/home' });
      return;
    }
  }, [isDiscoverTabEnabled]);

  return (
    <PageContainer
      contentContainerClassName="pb-lg flex flex-1 justify-between overflow-y-scroll"
      countSkeletons={16}
      innerContainerClassName="px-md"
      isLoading={isAnyLoading || !completedInitialFetch}
      isScrollable
      onScroll={handleScroll}
      padding="none"
    >
      <YStack className="w-full items-center py-sm lg:py-lg">
        <YStack className="max-w-screen-lg w-full">
          <YStack className="gap-xl pt-lg">
            <LetterRecommendationsContainer letterRecommendations={letterRecommendations ?? []} />
            {examples?.length ? <TrendingTasksContainer examples={examples} layout="horizontal" /> : null}
            <YStack>
              <DirectoryCard />
            </YStack>
            {isFooterVisible ? (
              <YStack className="items-center">
                <Text color="tertiary" type="caption">
                  What are you doing all the way down here? Go make a task!
                </Text>
              </YStack>
            ) : null}
          </YStack>
        </YStack>
      </YStack>
    </PageContainer>
  );
};

export const Route = createFileRoute('/app/discover')({
  component: Discover,
});
